export const DEFAULT_PAGE_SIZE = 10;

export const PageSizeValues = [10, 20, 30];

export const PageSizes = PageSizeValues.map(v => ({id: v, label: `${v}`}));
